import { Card, Flex, Form, Input } from 'antd'
import { UploadChangeParam } from 'antd/es/upload'
import { FormInstance, UploadFile } from 'antd/lib'

import { CustomItemRender, Text, Upload } from 'src/components'
import { useLocales } from 'src/locales'

import { CreateInvoiceCard } from './CreateInvoiceCard'
import { ReturnsConsumablesTable } from './ReturnsConsumablesTable'

type Props = {
  form: FormInstance
  onChange?: (info: UploadChangeParam<UploadFile>) => void
}

export const ReturnFormFields = ({ form, onChange }: Props) => {
  const { t } = useLocales()

  const medicineItems = Form.useWatch('medicine', form)

  const total = medicineItems?.reduce(
    (acc: number, item: { priceTotal: number }) =>
      acc + (item?.priceTotal ?? 0),
    0
  )

  return (
    <Flex vertical gap={16}>
      <CreateInvoiceCard form={form} />

      <Card>
        <Form.List name="medicine">
          {(fields, { add, remove }) => (
            <ReturnsConsumablesTable
              fields={fields}
              add={add}
              remove={remove}
              form={form}
            />
          )}
        </Form.List>
        <Flex justify="end" align="center" gap={8}>
          <Text weight={700}>{t('common.total')}: </Text>
          <Text weight={700}>{total ?? 0} MDL</Text>
        </Flex>
      </Card>

      <Card>
        <Card title={t('stock_applications.uploaded_documents')}>
          <Form.Item name="docs" className="full-width">
            <Upload
              onChange={onChange}
              customRequest={() => null}
              itemRender={(_, file, __, { remove }) => (
                <CustomItemRender file={file} onRemove={remove} />
              )}
            />
          </Form.Item>
        </Card>
      </Card>

      <Card>
        <Card title={t('common.comment')}>
          <Form.Item name="comment" className="full-width">
            <Input.TextArea rows={5} placeholder={t('common.leave_comment')} />
          </Form.Item>
        </Card>
      </Card>
    </Flex>
  )
}
